// Tab.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { color } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import media from '../style/media.js';

class Tab extends React.PureComponent {
  handleClick = event => {
    const { value, onChange } = this.props;
    onChange(event, value);
  };

  render() {
    const { isAnchorTab, label, value, onChange, labelStyle, ...otherProps } =
      this.props;
    if (isAnchorTab) {
      return (
        <StyledAnchorTab
          onClick={this.handleClick}
          data-key={value}
          {...otherProps}
        >
          {label}
        </StyledAnchorTab>
      );
    }
    return (
      <StyledTab onClick={this.handleClick} {...otherProps} data-key={value}>
        <Label style={labelStyle}>{label}</Label>
      </StyledTab>
    );
  }
}

Tab.propTypes = {
  isAnchorTab: PropTypes.bool,
  label: PropTypes.node,
  onChange: PropTypes.func,
  value: PropTypes.any,
  labelStyle: PropTypes.object,
};

Tab.defaultProps = {
  isAnchorTab: false,
  onChange: () => null,
  label: '',
};

const StyledTab = styled.a`
  ${({ as }) => {
    if (as === 'button') {
      return css`
        ${ResetButtonStyle};
      `;
    }
  }}
  display: block;
  transition: 0.2s;
  color: ${color.neutral[100]};
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  cursor: pointer;
`;

const StyledAnchorTab = styled.button.attrs(({ isActive }) => ({
  style: {
    backgroundColor: isActive ? color.neutral['20_alpha_40'] : 'transparent',
    color: isActive ? color.neutral[100] : color.neutral[30],
  },
}))`
  ${ResetButtonStyle};
  border-color: ${color.neutral[20]};
  border-style: solid;
  border-width: 1px 0px 1px 1px;
  padding: 2px 4px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  transition:
    background-color 0.2s,
    color 0.2s;
  :first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  :last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border-right-width: 1px;
  }
`;

const Label = styled.span`
  margin-left: 12px;
  margin-right: 12px;
  padding: 16px 2px;
  font-size: 16px;
  line-height: 1;
  white-space: nowrap;
  ${media.mobile`
    padding: 12px 2px;
    font-size: 14px;
  `};
`;

export default Tab;
